<template>
  <div id="confirmacao-sucesso">
    <img class="align-middle" :src="require('@/assets/img/img_helper_teleconsulta.svg')"/>
    <span class="text-middle-big">{{ textos.tituloInfomativoSelecaoResponsavel }}</span>
    <div class="detalhe-consulta">
      <el-card class="card-info" :style="`background: ${corPrimaria}1A`">
        <strong>Horário reservado:</strong><br/>
        {{sucessoAgendamento.profissional.nome}} - {{formatDataHora(sucessoAgendamento.agenda.dataHora)}}
      </el-card>
      <p class="description-extra">
        {{ textos.textoInfomativoSelecaoResponsavel }}
      </p>
      <el-button @click="nextStep" class="btn-principal" :style="`background:${corBtnPrincipal}`">
        <span :style="`color: ${corTextoBtnPrincipal}`">
          {{ textos.textoBotaoInfomativoSelecaoResponsavel }}
        </span>
      </el-button>
<!--      <el-button @click="goToHome" class="btn-principal" :style="`background:${corBtnPrincipal}`"><span :style="`color: ${corTextoBtnPrincipal}`">{{btnLabel}}</span></el-button>-->
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
export default {
  data () {
    return {
      itensCard: {},
      itens: ['paciente', 'médico', 'horário', 'local']
    }
  },
  computed: {
    ...mapState('Func53', ['agendamento', 'idAgenda', 'local', 'paciente', 'sucessoAgendamento']),
    ...mapGetters('SetupApp', ['estilo']),
    ...mapState('SetupApp', ['funcionalidade']),
    ...mapGetters('Func53', ['tipoServico', 'idServico']),
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    corBtnPrincipal () {
      return this.estilo.botaoPrincipal.corBotaoPrincipal
    },
    corTextoBtnPrincipal () {
      return this.estilo.botaoPrincipal.corTextoBotaoPrincipal
    },
    btnLabel () {
      return this.funcionalidade.parametros.textos.labelBotaoConcluir
    },
    labelTipoServico () {
      if (this.idServico) {
        return this.tipoServico.find(item => item.idServico === this.idServico).descricao
      }
      return ''
    },
    textos () {
      return this.funcionalidade.parametros.textos
    }
  },
  methods: {
    fullEndereco (endereco) {
      return `${endereco.cidade}, ${endereco.bairro}, ${endereco.endereco} </br> ${endereco.numero}`
    },
    formatDataHora (dataHora) {
      const data = moment(dataHora).format('DD/MM')
      const hora = moment(dataHora).format('HH:mm')
      return `${data} às ${hora}`
    },
    goToHome () {
      this.$router.push({ path: '/53' })
    },
    nextStep () {
      this.$router.replace({ query: { step: 6.2, contrato: this.paciente.numeroContrato } })
    }
  }
}
</script>
<style scoped>
  .description-extra {
    text-align: center;
  }
  .card-info {
    text-align: center;
  }
</style>
